import { AccountMigrationStatus } from "../type/enums";
import { createSelector } from '@reduxjs/toolkit';

export const getAccountIsFetching = state => state.accountReducer.isFetching;
export const getAccountError = state => state.accountReducer.error;
export const getAccount = state => state.accountReducer.account;
export const getAccountPostSuccess = state => state.accountReducer.postSuccess;
export const getAccountIsPosting = state => state.accountReducer.isPosting;
export const getAccountPostError = state => state.accountReducer.postError;

export const getIsFetchingAccounts = state => state.accountReducer.isFetchingAccounts;
export const getAccountsList = state => state.accountReducer.accountsList;
export const getShowAccountBlockedModal = state => state.accountReducer.showAccountBlockedModal;
export const getApiVersion = state => state.accountReducer.apiVersion;
export const getMigrationStatus = (state) => state.accountReducer.account.migrationStatus;

export const selectIsAccountMigrating = createSelector(
    getMigrationStatus,
    (migrationStatus) => migrationStatus === AccountMigrationStatus.MIGRATING
);
export const getIsV2ApiVersion = createSelector(
    getApiVersion,
    (apiVersion) => apiVersion === '/v2'
);